<template>
    <div id="mainpage" class="main-container">
        <hero-start/>
        <article>
            <idea/>
            <parallaxImages class="desktop-only" />
            <imageGrid class="mobile-only"></imageGrid>
        </article>
        <stripe-banner></stripe-banner>
        <shop></shop>
    </div>
</template>

<script>
import heroStart from '@/components/hero/StartHero.vue'
import imageGrid from '@/components/stories/ImageGrid.vue'
import idea from '@/components/stories/Idea.vue'
import parallaxImages from '@/components/stories/ParallaxImages.vue'
import shop from '@/components/shop/Shop.vue'
import stripeBanner from '@/components/shop/StripeBanner.vue'
export default {
name: 'mainpage',
  components: {
    heroStart,
    idea,
    shop,
    parallaxImages,
    imageGrid,
    stripeBanner
  }
}
</script>


